/** * @description 考勤打卡设置 * @author daxiong */
<template>
  <div id="attendanceSet">
    <div class="group">
      <van-cell
        to="/lishui/jurisdiction/administratorsList"
        :value="userLength > 0 ? '已设置' : '未设置'"
        is-link
        v-if="userInfo.staffType == 0 || userInfo.staffType == 2"
      >
        <template #title>
          <span class="custom-title">考勤管理员</span>
        </template>
      </van-cell>
      <van-cell to="/lishui/scanCode/attendanceCode" is-link>
        <template #title>
          <span class="custom-title">查看二维码</span>
        </template>
      </van-cell>
    </div>
    <div class="add-group">
      <van-cell to="/lishui/groupAdd">
        <template #title>
          <div class="cell-add">
            <van-icon name="add-o" />
            <span class="custom-title">新增考勤组</span>
          </div>
        </template>
      </van-cell>
    </div>
    <div class="group">
      <van-cell
        v-for="(item, index) in groupList"
        :key="index"
        :value="item.value"
        :to="`/lishui/groupEditor?id=${item.id}&name=${item.groupName}`"
        is-link
      >
        <template #title>
          <span class="custom-title">{{ item.groupName }}</span>
        </template>
      </van-cell>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { listPunchGroupSetting, getEmployeeAdmin } from '@api/lishui'
import { getLocalStorage } from '@utils'
export default {
  components: {},
  data() {
    return {
      userInfo: JSON.parse(getLocalStorage('lishuiUserInfo'))
        ? JSON.parse(getLocalStorage('lishuiUserInfo'))
        : {},
      groupList: [],
      userLength: 0,
      punchSetting: false,
      creditCodeInCookies: Cookies.get('lishuiCreditCode')
    }
  },
  computed: {},
  watch: {},
  methods: {
    administrators() {
      getEmployeeAdmin({
        creditCode: this.userInfo.creditCode || this.creditCodeInCookies,
        pageNum: 1,
        pageSize: 10
      }).then(res => {
        if (res.data.code === '0000') {
          this.userLength = res.data.data.results.length
        }
      })
    },
    /**
     * @description 查询考勤组个数
     */
    listPunchGroupSetting() {
      listPunchGroupSetting({
        creditCode: this.userInfo.creditCode,
        staffType: 0
      }).then(response => {
        let res = response.data
        if (res.code == '0000') {
          this.groupList = res.data
        }
      })
    }
  },
  created() {
    this.listPunchGroupSetting()
    this.administrators()
  },
  mounted() { }
}
</script>
<style lang="scss" scoped>
#attendanceSet {
  height: calc(100vh - 60px);
  font-size: 14px;
  .add-group {
    margin: 8px 0;
  }
  ::v-deep .van-cell {
    &__title {
      .cell-add {
        display: flex;
        align-items: center;
        color: #0091ff;
        i {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
